import { render } from "./OpeningTimes.vue?vue&type=template&id=ee1aaa2c&scoped=true"
import script from "./OpeningTimes.vue?vue&type=script&lang=js"
export * from "./OpeningTimes.vue?vue&type=script&lang=js"

import "./OpeningTimes.vue?vue&type=style&index=0&id=ee1aaa2c&lang=scss&scoped=true"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee1aaa2c"]])

export default __exports__